export const GET_LIST_OF_BOOKLETS =
  'src/modules/postResources/GET_LIST_OF_BOOKLETS';
export const GET_USERS_LIST =
  'src/modules/postResources/GET_USERS_LIST';
export const ADD_POST_RESOURCE =
  'src/modules/postResources/ADD_POST_RESOURCE';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/postResources/CANCEL_ALL_API_REQUESTS';
